import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import constants from '@/configuration/constants'

const checkUserHasFleets = (application) => {
  return clientHTTP.get(
    getLinkHref(application, 'fleets'),
    { page: 1, pageSize: 1, fields: 'id' },
    {},
    { defaultErrorMessage: false }
  )
}

const getAllFleets = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'fleets'), { sort: '+name' })
}

const getFleets = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'fleets'), params)
}

const getAllGateways = (entity, params = {}) => {
  return clientHTTP.getAll(getLinkHref(entity, 'gateways'), params)
}

const getGateways = (entity, params = {}) => {
  return clientHTTP.get(getLinkHref(entity, 'gateways'), params)
}

const getFleetLastStatistics = (fleet, params = {}) => {
  return clientHTTP.get(getLinkHref(fleet, 'fleetLastStatistics'), params)
}

const createGatewaysExport = (application, querySearch) => {
  return clientHTTP.post(getLinkHref(application, 'createGatewaysExport') + (querySearch ? `?search=${querySearch}` : ''))
}

const getGatewaysExportStatus = (proccessingUrl) => {
  return clientHTTP.get(constants.gmsUrl + proccessingUrl)
}

const createFleet = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'fleets'), params)
}

const updateFleet = (fleet, params = {}) => {
  return clientHTTP.put(getLinkHref(fleet, 'self'), params)
}

const deleteFleet = (fleet) => {
  return clientHTTP.delete(getLinkHref(fleet, 'self'))
}

export default {
  checkUserHasFleets,
  getAllFleets,
  getFleets,
  getAllGateways,
  getGateways,
  getFleetLastStatistics,
  createGatewaysExport,
  getGatewaysExportStatus,
  createFleet,
  updateFleet,
  deleteFleet
}
